import { useState } from 'react';
import { downloadFileFromTrpc } from 'further-ui/utils';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api, { ApiInputs, ApiResponses } from 'lib/trpcClient';

const usePeriodEndReportPreviewPdf = () => {
  const [inFlightInvestorPdfDownloads, setInFlightInvestorPdfDownloads] =
    useState<Set<string>>(new Set());

  const { mutate: downloadPreviewPdf } =
    api.periodEndReport.downloadPreviewPdf.useMutation(
      useHandleTrpcMutation<
        ApiResponses['periodEndReport']['downloadPreviewPdf'],
        ApiInputs['periodEndReport']['downloadPreviewPdf']
      >()({
        invalidations: [],
        onMutate: ({ investorId }) => {
          setInFlightInvestorPdfDownloads((prev) => {
            const newSet = new Set(prev);
            newSet.add(investorId);
            return newSet;
          });
        },
        onSuccess: ({ file, filename, mimeType }) => {
          downloadFileFromTrpc({
            content: file,
            name: filename,
            mimeType,
          });
        },
        onSettled: (_, __, input) => {
          setInFlightInvestorPdfDownloads((prev) => {
            const newSet = new Set(prev);
            newSet.delete(input.investorId);
            return newSet;
          });
        },
      }),
    );

  const isDownloadingPreviewPdf = (investorId: string) => {
    return inFlightInvestorPdfDownloads.has(investorId);
  };

  return {
    downloadPreviewPdf,
    isDownloadingPreviewPdf,
  };
};

export default usePeriodEndReportPreviewPdf;
